import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <header className="App-header">DICTIONARY</header>
      <h1> & THESAURUS </h1>
      <main>
        <Dictionary />
      </main>

      <footer>
        This App is coded by
        <a href="https://www.stellaricht.com/" target="_blank" rel="noreferrer">
          {" "}
          Stella Richt{" "}
        </a>
        and is opensourced on
        <a
          href="https://github.com/stellaricht/dictionaryapp"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          GitHub
        </a>
      </footer>
    </div>
  );
}

export default App;
